import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { CitiesLoadingDialog } from "./cities-loading-dialog/CitiesLoadingDialog";
import { CityDeleteDialog } from "./city-delete-dialog/CityDeleteDialog";
import { CitiesDeleteDialog } from "./cities-delete-dialog/CitiesDeleteDialog";
import { CitiesFetchDialog } from "./cities-fetch-dialog/CitiesFetchDialog";
import { CitiesUpdateStatusDialog } from "./cities-update-status-dialog/CitiesUpdateStatusDialog";
import { CitiesCard } from "./CitiesCard";
import { CitiesUIProvider } from "./CitiesUIContext";

function CitiesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CitiesDeleteDialog show={location.pathname === "/location/cities/deleteCities"} onHide={() => navigate("/location/cities")} />;
}
function CityDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <CityDeleteDialog show id={id} onHide={() => navigate("/location/cities")} />;
}
function CitiesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CitiesFetchDialog show={location.pathname === "/location/cities/fetch"} onHide={() => navigate("/location/cities")} />;
}
function CitiesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CitiesUpdateStatusDialog show={location.pathname === "/location/cities/updateStatus"} onHide={() => navigate("/location/cities")} />;
}

export function CitiesPage() {
  const navigate = useNavigate();
  const citiesUIEvents = {
    newCityButtonClick: () => navigate("/location/cities/new"),
    openEditCityPage: (id) => navigate(`/location/cities/${id}/edit`),
    openDeleteCityDialog: (id) => navigate(`/location/cities/${id}/delete`),
    openDeleteCitiesDialog: () => navigate("/location/cities/deleteCities"),
    openFetchCitiesDialog: () => navigate("/location/cities/fetch"),
    openUpdateCitiesStatusDialog: () => navigate("/location/cities/updateStatus"),
  };

  return (
    <CitiesUIProvider citiesUIEvents={citiesUIEvents}>
      <CitiesLoadingDialog />
      <Routes>
        <Route path="deleteCities" element={<CitiesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<CityDeleteDialogRoute />} />
        <Route path="fetch" element={<CitiesFetchDialogRoute />} />
        <Route path="updateStatus" element={<CitiesUpdateStatusDialogRoute />} />
      </Routes>
      <CitiesCard />
    </CitiesUIProvider>
  );
}
